import CarvanaHeader from '@carvana/header';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { usePrevious } from '@carvana/vdp-react-hooks';
import { useContext, useMemo, useEffect } from 'react';
import { commonEnvironment } from '~/constants/environment';
import FavoritesContext from '~/contexts/FavoritesContext';
import { useUserData } from '~/contexts/UserContext';
import useClientSide from '~/hooks/useClientSide';
import { loadHeaderMfe } from '~/utilities/MicroFrontEnds';

function useShouldRefreshProfile() {
  const { isLoggedIn } = useUserData();

  return usePrevious(isLoggedIn) !== isLoggedIn;
}

export default function Header() {
  const isClientSide = useClientSide();
  const { favorites: userFavorites } = useContext(FavoritesContext);
  const shouldRefreshProfile = useShouldRefreshProfile();

  const favorites = useMemo(
    () => ({ favorites: userFavorites }),
    [userFavorites]
  );

  useEffect(() => {
    loadHeaderMfe();
  }, []);

  const props = {
    environment: commonEnvironment,
    favorites,
    shouldLoadPlugin: false,
    shouldRefreshProfile,
    useProvider: true
  };

  return isClientSide ? (
    <MfeReactComponent
      component="default"
      fallback={{
        Component: <CarvanaHeader {...props} />,
        timeout: 30000
      }}
      loading={<CarvanaHeader {...props} />}
      module="HeaderModule"
      {...props}
    />
  ) : (
    <CarvanaHeader {...props} />
  );
}
